import { connect } from 'react-redux';
import _get from 'lodash-es/get';
import { closeTwoFactor, submitTwoFactor } from '../../../../actions/twoFactor';
import TwoFactor from './Twofactor';

const mapStateToProps = state => {
  const { twofactor } = state;
  const { isVisible = false, payload = {}, hash = '' } = twofactor;
  const { actionType = '' } = payload;
  const payloadWithHash = { hash, ...payload };
  return {
    ...state,
    isVisible,
    loading: _get(state, `apiState.${actionType}.isFetching`, false),
    body: payloadWithHash,
    actionType,
  };
};

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(closeTwoFactor()),
  submit: payload => dispatch(submitTwoFactor(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TwoFactor);
